export const getSentryConfig = () => ({
  dsn: "https://610085e8310e429ea41b5f0d14697483@o52995.ingest.sentry.io/5210954",
  debug: process.env.NODE_ENV === "development",
  enabled: process.env.NODE_ENV === "production",
  environment: process.env.REACT_APP_SENTRY_APP_ENV,
  release: process.env.REACT_APP_SENTRY_GIT_SHA,
})
